import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../layout/Table/SimpleRow";
import {
  EMAIL_CAMPAIGN_RECIPIENTS_TYPES,
  TRANSLATED_EMAIL_CAMPAIGN_RECIPIENTS,
  TRANSLATED_EMAIL_CAMPAIGN_STATUSES,
  TRANSLATED_EMAIL_CAMPAIGN_TEMPLATES,
} from "../../../../../config/constants";
import moment from 'moment';

function EmailCampaignDetailsTable(props) {
  const { emailCampaign } = props;

  if (! emailCampaign || ! emailCampaign.id) {
    return <Table className="align-items-center email-campaign-details-table table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center email-campaign-details-table table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.emailCampaigns.table.template" value={TRANSLATED_EMAIL_CAMPAIGN_TEMPLATES[emailCampaign.template]}/>
      <SimpleRow translationKey="components.pages.emailCampaigns.table.recipients" value={TRANSLATED_EMAIL_CAMPAIGN_RECIPIENTS[emailCampaign.recipients_type]}/>
      <SimpleRow translationKey="components.pages.emailCampaigns.table.status" value={TRANSLATED_EMAIL_CAMPAIGN_STATUSES[emailCampaign.status]}/>
      {
        emailCampaign.recipients_type === EMAIL_CAMPAIGN_RECIPIENTS_TYPES.TEST_USERS &&
        <SimpleRow translationKey="components.pages.emailCampaigns.table.email" value={emailCampaign.recipient_test_email	}/>
      }
      {
        emailCampaign.recipients_type === EMAIL_CAMPAIGN_RECIPIENTS_TYPES.SELECTED_USERS &&
        emailCampaign.selected_users && emailCampaign.selected_users.length > 0 &&
        <SimpleRow translationKey="components.pages.emailCampaigns.table.selected_user_emails" value={emailCampaign.selected_users.map((selectedUserEmail, index) => {return `${index > 0 ? ", " : ""}${selectedUserEmail.email}`})}/>
      }
      <SimpleRow translationKey="components.pages.emailCampaigns.table.created_at" value={moment(emailCampaign.created_at).format('LLL')}/>
      </tbody>
    </Table>
  );
}

export { EmailCampaignDetailsTable };
